// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"2821d90c","488":"021abcc2"}[chunkId] + ".chunk.js";
};